import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getAllergies = () =>
  graphqlHelper({
    query: graphql.allergy.queries.get,
    variables: {},
  });

export {
  // eslint-disable-next-line import/prefer-default-export
  getAllergies,
};



// WEBPACK FOOTER //
// ./src/services/allergy.js